// extracted by mini-css-extract-plugin
module.exports = {"NumericRangeFeature":"vw_a bhe_b bhe_ux"};